import { initializeApp } from 'firebase/app';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

// Configuration hardcodée pour résoudre les problèmes de variables d'environnement
const firebaseConfig = {
  apiKey: "AIzaSyBUkuBFiTGK3JqvM3LfO27an1t9bqFRUOQ",
  authDomain: "diotranscript.firebaseapp.com",
  projectId: "diotranscript",
  storageBucket: "diotranscript.firebasestorage.app",
  messagingSenderId: "241425604640",
  appId: "1:241425604640:web:e6f8d430b40ebe61345c45"
};

// Initialiser Firebase
const app = initializeApp(firebaseConfig);

// Initialiser Firestore avec des paramètres optimisés pour la reconnexion
const db = getFirestore(app);

// Configuration optimisée pour la gestion des connexions
// Améliorer la gestion hors ligne et la reconnexion automatique
if (typeof window !== 'undefined') {
  // Configuration pour la persistance hors ligne (déjà activée par défaut)
  // La persistance permet de continuer à fonctionner même en mode offline
  
  // Ajouter un gestionnaire pour surveiller la connexion Firestore
  let isOnline = true;
  
  // Écouter les changements de statut réseau pour Firestore
  window.addEventListener('online', () => {
    isOnline = true;
  });
  
  window.addEventListener('offline', () => {

    isOnline = false;
  });
  
  // Exposer le statut de connexion
  window.__firestoreConnectionStatus = () => isOnline;
}

const storage = getStorage(app);
const auth = getAuth(app);
const functions = getFunctions(app, 'us-central1');

// Configuration de l'authentification pour une meilleure persistance
// Firebase Auth maintient automatiquement la session utilisateur
if (typeof window !== 'undefined') {
  // Ajouter un gestionnaire global pour les erreurs d'authentification
  auth.onAuthStateChanged((user) => {
    if (user) {
    } else {
    }
  });
}

export { app, db, storage, auth, functions };